import { useMemo } from 'react';
import { useQuery } from 'convex/react';
import { api } from '../../../convex/_generated/api';
import { activitiesFromConvexDocs } from './activitiesFromConvex';

/**
 * Activities with display `images` from each doc’s `imageUrls`.
 * Use `api.activities.listWithImageUrls` after that query is deployed (resolves storage IDs).
 */
export function useActivitiesWithImages() {
  const docs = useQuery(api.activities.list);
  return useMemo(() => activitiesFromConvexDocs(docs ?? undefined), [docs]);
}
